/**
*
* CapCard
*
*/

import CapCustomCard from './CapCustomCard';
import CapCustomCardList from './CapCustomCardList';

CapCustomCard.CapCustomCardList = CapCustomCardList;

export default CapCustomCard;
